/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarouselRequestMoreImages_viewer = {
    readonly videoPdpEnabled: boolean | null;
    readonly " $refType": "PdpRespHeroCarouselRequestMoreImages_viewer";
};
export type PdpRespHeroCarouselRequestMoreImages_viewer$data = PdpRespHeroCarouselRequestMoreImages_viewer;
export type PdpRespHeroCarouselRequestMoreImages_viewer$key = {
    readonly " $data"?: PdpRespHeroCarouselRequestMoreImages_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarouselRequestMoreImages_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespHeroCarouselRequestMoreImages_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "videoPdpEnabled",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "videoPdpEnabled"
        }
      ],
      "storageKey": "isEnabled(key:\"videoPdpEnabled\")"
    }
  ]
};
(node as any).hash = 'c99ed71069cc21c159a9d9a5e92a82d1';
export default node;
